import React, { useState, useRef, useEffect } from "react";

import Nav from "react-bootstrap/Nav";
import axios from "axios";
import Table from "react-bootstrap/Table";
import loading1 from "../../assets/img/loading-gif.gif";
import loadingwithdraww from "../../assets/img/loading-gif.gif";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import { MdCurrencyRupee } from "react-icons/md";

import $ from "jquery";
import { fetchwalletamount } from "../../common.js";
import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { Button, Form, Input, message, Space, Modal } from "antd";
import Withdrawhistory from "./Withdrawhistory.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";
import { useLocation } from "react-router-dom";

export default function Wallet() {
    const location = useLocation();

    const amount = location.state?.amount || 0;
    localStorage.setItem("amount", amount)
    const navigate = useNavigate();
    const handleAdd = () => {
        navigate("/Transaction");
    };
    const handleQr = () => {
        navigate("/TransactionQR");
    };
 const isAdmined = localStorage.getItem("isAdmin");
    const userTokened = localStorage.getItem("userToken");
    useEffect(() => {
    
      if (!userTokened  || !isAdmined === "false") {
        navigate("/");
        localStorage.clear();
      }
    }, [!isAdmined]);
    return (
        <>
            {/* {loading123 ? (
                <div className="spinner-wrapper">
                    <div className="loadernew2"></div>
                </div>// Show loading message
            ) : ( */}

            <section className="transctionformdesign">
                <div className="overlayimagebg"></div>

                <Container>
                    <div className="form_tranaction">
                        <Tab.Container
                            id="left-tabs-example"
                            defaultActiveKey="first"
                            className="w-100"
                        >
                            <div className="card rounded">
                                <Tab.Content>
                                    <div className="tab_content_one position-relative">
                                        <h5 className="amoounttotal">Amount :<strong> <MdCurrencyRupee />{amount}</strong></h5>

                                        {/* <center> */}
                                        {/* {activeQRCodes.status != 'active' &&
                                            <div className="transactiondesign_form">
                                                <div className="selection w-100">
                                                    <select onChange={handleBankSelect} className="form-select">
                                                        <option value="">Select a bank</option>
                                                        {filteredValues1.map((bank) => (
                                                            <option key={bank._id} value={bank._id}>
                                                                {bank.bankName}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>
                                        } */}


                                    </div>
                                    <div className="p-3">
                                        <div className="ms-3">
                                            Select Payment Type
                                        </div>
                                        <div className="tab_content_one position-relative d-flex ">

                                            <div className="bankdetails_design_new w-50" style={{ cursor: 'pointer' }} onClick={handleAdd}>
                                                <p className="">
                                                    Bank
                                                </p>
                                            </div>
                                            <div className="bankdetails_design_new w-50" style={{ cursor: 'pointer' }} onClick={handleQr}>
                                                <p className="">
                                                    QR
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Content>


                            </div>
                        </Tab.Container>

                    </div>
                </Container>

                <ToastContainer />
            </section>
            {/* )} */}
        </>
    );
}
